module.exports = __webpack_public_path__ + "img/Math.d88dae1c.png";